import React, { useCallback } from 'react';

import { Calendly } from './Calendly';

import arrowRight from '../img/arrowRight.svg';
import exportCodeTip from '../img/hero/exportCodeTip.svg';
import promptsTip from '../img/hero/promptsTip.svg';
import screenshot from '../img/hero/screenshot@2x.png';
import user1 from '../img/hero/user1.png';
import user2 from '../img/hero/user2.png';
import user3 from '../img/hero/user3.png';

export const Hero = React.memo(() => {
  const handleMouseMove = useCallback((e, elementId) => {
    const element = document.getElementById(elementId);
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = ((y - centerY) / centerY) * 3;
    const rotateY = ((x - centerX) / centerX) * -3;

    const animationFrame = requestAnimationFrame(() => {
      element.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(5px)`;
    });

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const handleGetStarted = useCallback(() => {
    window.open('https://app.webcrumbs.ai', '_blank');
  }, []);

  const handleGithub = useCallback(() => {
    window.open('https://github.com/webcrumbs-community/webcrumbs', '_blank');
  }, []);

  const handleDemo = useCallback(() => {
    window.open('https://webcrumbs.me/eZ9wqS', '_blank');
  }, []);

  const handleMouseMoveScreenshot = useCallback((e) => handleMouseMove(e, 'screenshot'), [handleMouseMove]);

  return (
    <div id="home" className="flex flex-col items-center justify-between p-[20px] pt-[188px]">
      <div className="flex w-full flex-wrap items-center justify-center">
        <div className="flex w-full flex-col items-center">
          <div
            className="group mb-[20px] flex h-[35px] w-[282px] cursor-pointer items-center justify-center rounded-full bg-white transition-all duration-200 hover:shadow-2xl"
            data-aos="fade-down"
            onClick={handleGithub}
          >
            <div className="flex items-center -space-x-3">
              <img
                src={user1}
                alt="User 1"
                className="size-[25px] transition-transform duration-200 ease-in-out hover:scale-105"
              />
              <img
                src={user2}
                alt="User 2"
                className="size-[25px] transition-transform duration-200 ease-in-out hover:scale-105"
              />
              <img
                src={user3}
                alt="User 3"
                className="size-[25px] transition-transform duration-200 ease-in-out hover:scale-105"
              />
            </div>

            <p className="ml-[13px] leading-[27px] transition-all duration-200 group-hover:text-primary">
              1,500+ Stars on GitHub
            </p>
          </div>
          <h1
            className="text-center text-[36px] leading-[41px] text-[#120A0B] sm:text-[42px] sm:leading-[48px] md:text-[50px] md:leading-[58px] lg:text-[69px] lg:leading-[83px]"
            data-aos="fade"
          >
            <div className="font-bold">
              Ship <span className="hidden sm:inline">interfaces</span> faster with{' '}
            </div>
            <span className="font-extrabold">Frontend AI</span>
          </h1>
          <div
            className="mt-[18px] flex max-w-[500px] text-center 
            text-[18px] font-light leading-[30px] text-neutral-900
            md:mt-[20px] md:max-w-[600px] md:text-[20px] md:leading-[34px]
            lg:mt-[26px] lg:max-w-[700px] lg:text-[24px] lg:leading-[34px]
            "
            data-aos="fade-up"
            data-aos-delay="200"
          >
            The tool developers need to deliver stunning interfaces that wow clients and stakeholders—fast.
          </div>
          <div className="mt-[32px] flex flex-col justify-between gap-[16px] sm:flex-row" data-aos="zoom-in">
            <button
              className="h-[46px] rounded-full bg-primary-300 px-[30px] text-[16px] font-semibold leading-[26px] text-[#120A0B] transition-all duration-200 hover:scale-105 hover:shadow-2xl active:scale-100 active:shadow-none sm:h-[50px]"
              onClick={handleGetStarted}
            >
              Get Started
            </button>
            <Calendly>
              <div className="group flex h-[46px] flex-wrap items-center gap-[6px] rounded-full bg-white px-[30px] text-[16px] font-semibold leading-[26px] text-[#120A0B] transition-all duration-200 hover:scale-105 hover:shadow-2xl active:scale-100 active:shadow-none sm:h-[50px]">
                <span className="transition-transform duration-200">Talk to us</span>
                <img
                  src={arrowRight}
                  alt="Arrow Right"
                  className="transition-transform duration-200 group-hover:translate-x-1"
                />
              </div>
            </Calendly>
          </div>
          <div
            className="flex w-full max-w-full items-center justify-center gap-4"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            <img
              src={promptsTip}
              alt="Generate Image"
              className="max-h-[92px] w-1/2 transition-transform duration-300 hover:scale-105 "
            />
            <img
              src={exportCodeTip}
              alt="Code Tip"
              className="max-h-[92px] w-1/2 transition-transform duration-300 hover:scale-105 "
            />
          </div>
          <div
            className="flex max-w-full cursor-pointer items-center justify-center gap-4"
            data-aos="fade-up"
            data-aos-delay="600"
            onClick={handleDemo}
            onMouseMove={handleMouseMoveScreenshot}
          >
            <div id="screenshot" className="custom-card-transform group relative mb-[30px] max-w-[1139px]">
              <img src={screenshot} alt="Hero Screen" className="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
